import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Location from '@solvhealth/types/interfaces/Location';
import PageContainer from '../SolvPatternLibrary/PageContainer';
import InsuranceForm from './InsuranceForm';
import InsuranceFileUpload from './InsuranceFileUpload';
import Title from './components/Title';
import VerticallyAlignedContainer from '../SolvPatternLibrary/VerticallyAlignedContainer';
import { ADD_INSURANCE_ORIGIN_USER_PROFILE } from '../../core/util/bookingFlowRouting';
import { OriginType } from '../../core/util/bookingFlowRoutingTypes';
import { isPhotoOnlyInsuranceFlow } from '../../core/util/location';
import { getNewBookingLocale } from '../../selectors/newBooking';
import { capitalCase } from '../../core/util/string';
import { AddInsuranceActions } from '~/routes/addInsurance';
import { ImageType } from '~/sagas/images';

const StyledPageContainer = styled(PageContainer).withConfig({ componentId: 'sc-vv307t-0' })`
  width: 100%;
`;

type Props = {
  location: Location;
  origin: OriginType;
  handleFileChange: (
    imageType: ImageType,
    location: Location,
    afterChangeActions: AddInsuranceActions
  ) => any;
  handleSkip: () => void;
  onClickFront: (...args: any[]) => any;
  onClickBack: (...args: any[]) => any;
};

const DesktopAddInsurance = (props: Props) => {
  const { location, origin } = props;
  const { t } = useTranslation('addInsurance');
  const locale = useSelector(getNewBookingLocale);
  const isMobileFlow = false;
  return (
    <VerticallyAlignedContainer>
      <StyledPageContainer container justify="center" spacing={3}>
        <Grid item xs={12}>
          <Title>{t('addInsurance.capitalCase')}</Title>
        </Grid>
        {(!location.isInsurancePhotoUploadAndOcrDisabled ||
          origin === ADD_INSURANCE_ORIGIN_USER_PROFILE) && <InsuranceFileUpload {...props} />}
        {!isPhotoOnlyInsuranceFlow(location) && (
          <InsuranceForm isMobileFlow={isMobileFlow} locale={locale} {...props} />
        )}
      </StyledPageContainer>
    </VerticallyAlignedContainer>
  );
};

export default DesktopAddInsurance;
